export const configuration = {
  font_size_list: [
    {"label": "36px", "value": 36},
    {"label": "37px", "value": 37},
    {"label": "38px", "value": 38},
    {"label": "39px", "value": 39},
    {"label": "40px", "value": 40},
    {"label": "41px", "value": 41},
    {"label": "42px", "value": 42},
    {"label": "43px", "value": 43},
    {"label": "44px", "value": 44},
    {"label": "45px", "value": 45},
    {"label": "46px", "value": 46},
    {"label": "47px", "value": 47},
    {"label": "48px", "value": 48},
    {"label": "49px", "value": 49},
    {"label": "50px", "value": 50}
  ],
  default_color_draw: '#000000',
  default_font_size_draw: 40,
  default_size_stroke_draw: 1
}
